module.exports = __webpack_public_path__ + "static/media/icon_dna.2312614b.svg";